import { graphql } from '../../gql';

export const SKILL_TAXONOMIES_VERSIONS_QUERY = graphql(`
  query SkillTaxonomiesVersions {
    selectionList {
      skill_taxonomies {
        taxs {
          id
          is_latest
          name
          version
        }
      }
    }
  }
`);
